module.exports = __webpack_public_path__ + "static/img/8.8826628.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/eng/8.png
// module id = VtwY
// module chunks = 0